import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { SharedModule } from '../shared/shared.module';
import { MediaLibraryComponent } from './media-library/media-library.component';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
	MaterialModule,
	SharedModule,
	MediaLibraryComponent
  ],
  exports: [
    CommonModule,
	MediaLibraryComponent
  ]
})
export class ProjectModule { }
